import React from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <>
      <div className="miniHeader">
        <ul>
          <NavLink
            to="/publishers"
            className={({ isActive }) => (isActive ? "active-route" : "")}
          >
            <li>Publishers</li>
          </NavLink>
          |
          <NavLink
            to="/categories"
            className={({ isActive }) => (isActive ? "active-route" : "")}
          >
            <li>Categories</li>
          </NavLink>
          |
          <NavLink
            to="/formats"
            className={({ isActive }) => (isActive ? "active-route" : "")}
          >
            <li>Formats</li>
          </NavLink>
          |
          <NavLink
            to="/supplytype"
            className={({ isActive }) => (isActive ? "active-route" : "")}
          >
            <li>Inventory Type</li>
          </NavLink>
        </ul>
        <br />
      </div>
    </>
  );
}

export default Navbar;
